import React, {useState, useEffect} from "react";
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap";

//Import Image
import lightLogo from "../../assets/images/Avanza_Empleo.png";
import darkLogo from "../../assets/images/Avanza_Empleo.png";
import { useNavigate, useLocation } from "react-router-dom";
import signInImage from "../../assets/images/auth/sign-in.png";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { supabaseLogin } from '../../services/supabaseAuth';
import { getEmployees, getUserInfo, getCompany } from '../../services/userservice';
import login_button from "../../assets/images/buttons/login_button.png"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate(); // Utiliza el hook
  const registro = localStorage.getItem("registro");
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  var parrafo ="Ingresa a tu cuenta registrada con tu correo electrónico o número de identificación y contraseña.";
  if (registro==='registro'){
    parrafo = "Usuario Creado con exito por favor ingrese";
    localStorage.setItem("registro","");
  }
  
  document.title = "Avanza Empleo | Iniciar Sesión";

  useEffect(() => {
    if (location.state?.requireAuth) {
      toast.warning("Tu sesión ha expirado o necesitas iniciar sesión.");
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const handleSubmit = async (e) => {
    localStorage.clear()
    e.preventDefault();
    setIsLoading(true);
    try {
      await supabaseLogin(email, password);
      // Llamar a la función para obtener información
      const userInfo = await getUserInfo();

      localStorage.setItem("nombre", userInfo.username);
      localStorage.setItem("email", userInfo.email);
      localStorage.setItem("id", userInfo.id);
      localStorage.setItem("rol", userInfo.role_id);

      
      //Si el rol es employee
      if (userInfo.role_id === 2) {
        try {
          const employeeInfo = await getEmployees(userInfo.id);
          localStorage.setItem("employeeId", employeeInfo.id);
        } catch (err) {
          // ✅ Solo redirigir al perfil si es 404 (empleado no encontrado)
          if (err.response?.status === 404) {
            toast.info("Debe completar su perfil para utilizar toda la aplicación. Será redirigido a la página de perfil.");
            setTimeout(() => {
              navigate('/myProfile');
            }, 3000);
            return false;
          }
          // ❌ Cualquier otro error sí debe mostrarse
          toast.error("Error al obtener información del empleado.");
          return false;
        }
      }

      // El usuario es empresa
      if (userInfo.role_id === 1) {
        try {
          const companyInfo = await getCompany(userInfo.id);
          localStorage.setItem("companyId", companyInfo.id);
        } catch (err) {
          // ✅ Solo redirigir al perfil si es 404 (empleado no encontrado)
          if (err.response?.status === 404) {
            toast.info("Debe completar su perfil para utilizar toda la aplicación. Será redirigido a la página de perfil.");
            setTimeout(() => {
              navigate('/myProfile');
            }, 3000);
            return false;
          }
          // ❌ Cualquier otro error sí debe mostrarse
          toast.error("Error al obtener información del empleado.");
          return false;
        }
      }

      navigate('/'); // Redirige al usuario a la página principal
      return true;
    } catch (err) {
      console.error('Error:', err);
      if (err.response?.status === 403) {
        localStorage.setItem("errId", "1");
        window.dispatchEvent(new Event("auth-error"));
        toast.error("Tu cuenta está bloqueada. Contacta con soporte.");
        return;
      }
      setIsLoading(false);
      toast.error(err.message || "Error al iniciar sesión, por favor inténtalo de nuevo.");
    }
  };


  return (
    <React.Fragment>
      <div>
        <div className="main-content">
          <div className="page-content">
            <section className="bg-auth">
              <Container>
                <Row className="justify-content-center">
                  <Col xl={10} lg={12}>
                    <Card className="auth-box">
                      <Row className="g-0">
                        <Col lg={6} className="text-center">
                          <CardBody className="p-4">
                            <Link to="/">
                              <img
                                src={lightLogo}
                                alt=""
                                className="logo-light"
                                style={{ width: "180px" }}
                              />
                              <img
                                src={darkLogo}
                                alt=""
                                className="logo-dark"
                                style={{ width: "180px" }}
                              />
                            </Link>
                            <div className="mt-5">
                              <img
                                src={signInImage}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </CardBody>
                        </Col>
                        <Col lg={6}>
                          <CardBody className="auth-content p-5 h-100 text-white">
                            <div className="w-100">
                              <div className="text-center mb-4">
                                <h5>BIENVENIDO DE NUEVO</h5>
                                {parrafo && <p className="text-white-70">{parrafo}</p>}
                              </div>
                              <Form action="/" className="auth-form" onSubmit={handleSubmit}>
                                <div className="mb-3">
                                  <label
                                    htmlFor="usernameInput"
                                    className="form-label"
                                  >
                                    Correo electrónico
                                  </label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="usernameInput"
                                    placeholder="Correo electronico"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                </div>
                                <div className="mb-3">
                                  <label
                                    htmlFor="passwordInput"
                                    className="form-label"
                                  >
                                    Contraseña
                                  </label>
                                  <div className="input-group">
                                    <Input
                                      type={showPassword ? "text" : "password"}
                                      className="form-control"
                                      id="passwordInput"
                                      placeholder="Contraseña"
                                      required
                                      value={password}
                                      onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-outline-light border"
                                      onClick={() => setShowPassword(!showPassword)}
                                      title={showPassword ? "Ocultar contraseña" : "Ver contraseña"}
                                      aria-label={showPassword ? "Ocultar contraseña" : "Ver contraseña"}
                                    >
                                      <i className={showPassword ? "uil uil-eye-slash" : "uil uil-eye"} style={{ fontSize: "1.2rem" }}></i>
                                    </button>
                                  </div>
                                </div>
                                <div className="mb-4">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="flexCheckDefault"
                                    />
                                    <Link
                                      to="/resetpassword"
                                      className="float-end text-white"
                                    >
                                      ¿Has olvidado tu contraseña?
                                    </Link>
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Recordarme
                                    </label>
                                  </div>
                                </div>
                                <div className="text-center">
                                  <button
                                    type="submit"
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      padding: 0,
                                      cursor: 'pointer'
                                    }}
                                    disabled={isLoading}
                                  >
                                    <img src={login_button} height="50.5" alt="Iniciar Sesión" className="logo-dark" />
                                  </button>
                                </div>
                              </Form>
                              <div className="mt-4 text-center">
                                <p className="mb-0">
                                  ¿No tengo cuenta?{" "}
                                  <Link
                                    to="/signup"
                                    className="fw-medium text-white text-decoration-underline fs-4"
                                  >
                                    {" "}
                                    Registrate Aquí{" "}
                                  </Link>
                                </p>
                              </div>
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default SignIn;
